"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _ActionList = _interopRequireDefault(require("./ActionList.styles"));
var _excluded = ["items", "onClose", "onSelect", "width"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @deprecated ActionList is deprecated as of version 1.9.0. Please use the Menu component instead.
 */

var ActionList = function ActionList(_ref) {
  var items = _ref.items,
    onClose = _ref.onClose,
    onSelect = _ref.onSelect,
    width = _ref.width,
    props = _objectWithoutProperties(_ref, _excluded);
  // HOOKS
  var classes = (0, _ActionList.default)({
    width: width
  });

  // EVENTS
  var handleClick = function handleClick(event, item) {
    if (onClose) {
      onClose(event, 'backdropClick');
    }
    if (onSelect) {
      onSelect(item);
    }
  };
  // STYLES
  var cssMenuPaper = (0, _classnames.default)(classes.menuPaper, _defineProperty({}, classes.customWidth, width));
  var cssMenuList = (0, _classnames.default)(classes.menuList);
  return /*#__PURE__*/_react.default.createElement(_core.Menu, _extends({
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PopoverClasses: {
      paper: cssMenuPaper
    },
    classes: {
      list: cssMenuList
    },
    marginThreshold: 4
  }, props), items && items.map(function (item) {
    var cssMenuItem = (0, _classnames.default)(classes.menuItem, {
      selected: item.isSelected
    });
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: item.text,
      classes: {
        root: cssMenuItem
      },
      onClick: function onClick(event) {
        return handleClick(event, item);
      }
    }, item.text);
  }));
};
var _default = ActionList;
exports.default = _default;